import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { useWizard } from 'react-use-wizard';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { generateErrorsForRequiredFields } from 'nallian-shared-ui/lib/lib/validate';
import { Grid, Flex, Field, Button } from 'nallian-shared-ui/lib/components';
import {
  InputFieldValueComponent,
  SelectFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { countryOptions } from '../../../../app/constants/countries';
import { OrganisationFormFlexWrapper } from '../../../styles';

const REQUIRED_FIELDS = ['name', 'streetAndNumber', 'postalCode', 'city', 'country'];

const CompleteOrganisationForm = ({ handleSubmit, setData }) => {
  const { t } = useTranslation();
  const { nextStep } = useWizard();

  const handleCompleteForm = useCallback(
    values => {
      setData(values);
      nextStep();
    },
    [setData, nextStep]
  );

  return (
    <OrganisationFormFlexWrapper fluid direction="column" margin="2rem 0 0">
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Field
            fluid
            name="name"
            label={t('organisationName')}
            placeholder={t('organisationName')}
            valueComponent={InputFieldValueComponent}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            name="streetAndNumber"
            label={t('streetAndNumber')}
            placeholder={t('streetAndNumber')}
            valueComponent={InputFieldValueComponent}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            name="postalCode"
            label={t('postalCode')}
            placeholder={t('postalCode')}
            valueComponent={InputFieldValueComponent}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            name="city"
            label={t('city')}
            placeholder={t('city')}
            valueComponent={InputFieldValueComponent}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            search
            clearable
            name="country"
            label={t('country')}
            placeholder={t('country')}
            valueComponent={SelectFieldValueComponent}
            options={countryOptions}
          />
        </Grid.Column>
      </Grid>
      <Flex fluid margin="1.5rem 0 0 0.5rem" justifyContent="flex-end">
        <Button
          btnprimary
          margin="0"
          content={t('continue')}
          onClick={handleSubmit(handleCompleteForm)}
        />
      </Flex>
    </OrganisationFormFlexWrapper>
  );
};

CompleteOrganisationForm.propTypes = {
  setData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

const validate = values => {
  let errors = {};
  errors = generateErrorsForRequiredFields(REQUIRED_FIELDS, values, errors);

  return errors;
};

export default compose(
  reduxForm({
    validate,
    form: 'completeOrganisation',
    enableReinitialize: true,
  })
)(CompleteOrganisationForm);
